/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { Autocomplete, Box, createFilterOptions } from "@mui/material";
import { useHistory } from "react-router-dom";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { templateStrings } from "../../../../Constant";
import { fetchCityOperatorsAction } from "../../../../redux/action-creators/operatorSettlementConfig";
import { fetchOperatorConfigAction } from "../../../../redux/action-creators/operatorConfigEditActionCreator";
import { setSettlementCycle } from "../../../../redux/actions/operatorSettlementConfigAction";
import { operatorConfigCity } from "../../../../redux/actions/operatorConfigEdit";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  stringify: (option) => option.cityName,
  limit: 500,
});

const renderOption = (params, option) => (
  <li {...params} key={option.cityId}>
    {option.cityName}
  </li>
);

function OperatorConfig() {
  const dispatch = useDispatch();
  const content = useSelector(
    (state) => state.OperatorSettlementConfig?.cityOperatorsList?.data || [],
  );
  const configCity = useSelector((state) => state.operatorConfigEdit?.selectedCity);

  const totalItems = useSelector(
    (state) => state.OperatorSettlementConfig?.cityOperatorsList?.totalItems ?? 0,
  );

  const refresh = useSelector(
    (state) => state.OperatorSettlementConfig?.isSettlementCycleSaved?.success,
  );

  const headerLoader = useSelector((state) => state?.loadingBar?.header);

  const [selectedCity, setSelectedCity] = useState(configCity || {});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNo, setPageNo] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [sortBy, setSortBy] = useState("");
  const [selected, setSelected] = useState([]);

  const templateString = templateStrings.operatorConfig;

  const getList = useCallback(() => {
    dispatch(fetchCityOperatorsAction({
      cityId: selectedCity.cityId,
      pageNo,
      pageSize: rowsPerPage,
    }));
  }, [dispatch, selectedCity.cityId, pageNo, rowsPerPage]);

  useEffect(() => {
    if (configCity && configCity.cityId && configCity.cityId !== selectedCity.cityId) {
      setSelectedCity(configCity);
    } else if (!configCity?.cityId) {
      setSelectedCity({});
    }
  }, [configCity]);

  const cities = useSelector((state) => state.Cities.cities);

  const history = useHistory();
  const handleAction = (row) => {
    dispatch(fetchOperatorConfigAction({
      operatorId: row?.operatorId,
    }));
    history.push({
      pathname: "/system-config/operator-config/edit",
      state: {
        city: selectedCity,
        rowData: row,
      },
    });
  };

  const handleChange = useCallback(
    (input, value) => {
      switch (input) {
        case "pageNo":
          setPageNo(value);
          break;
        case "rowsPerPage":
          setRowsPerPage(value);
          break;
        case "selected":
          const selectedOperatorId = !value.length ? [] : value;
          setSelected(selectedOperatorId);
          break;
        default:
          break;
      }
    },
    [selected],
  );

  useEffect(() => {
    if (selectedCity?.cityId) {
      getList();
    }
  }, [selectedCity, pageNo, rowsPerPage]);

  useEffect(() => {
    if (refresh) {
      getList();
      dispatch(setSettlementCycle({ success: false }));
    }
  }, [refresh]);

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header
          heading="Operator Settlement Configuration"
          hideS
          removeFilterOnly
        >
          <div className="flex pull-right">
            <Autocomplete
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 43,
                  width: 250,
                  padding: "0 0 0 9px",
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  borderColor: "black", // Set the border color to black
                  backgroundColor: "white",
                  zIndex: -1,
                  height: 45,
                  padding: 0,
                },
                "& .MuiInputLabel-outlined": {
                  transform: "translate(10px, 12px) scale(1)",
                },
                "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                  transform: "translate(7px, -6px) scale(0.75)",
                },
                "& .MuiIconButton-root": {
                  padding: 0,
                  margin: 0,
                },
                "& .MuiInputBase-root": {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                },
                "& .Mui-focused": {
                  borderColor: "black",
                },

              }}
              data-testid="operator-config"
              value={selectedCity}
              getOptionLabel={(option) => option.cityName || ""}
              options={cities}
              filterOptions={filterOptions}
              onChange={(event, newValue) => {
                setSelectedCity(newValue || {});
                dispatch(operatorConfigCity(newValue || {}));
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select City" variant="outlined" />
              )}
              renderOption={renderOption}
            />
          </div>
        </PageWrapper.Header>
        {!selectedCity?.cityName ? (
          <Box className="operator-config-body">
            Select city to view operators!
          </Box>
        ) : (
          <PageWrapper.Body>
            <TableWrapper
              content={!headerLoader && content}
              selected={selected}
              pageNo={pageNo}
              uniqueKey="operatorId"
              rowsPerPage={rowsPerPage}
              count={totalItems}
              handleChange={handleChange}
              templateString={templateString}
              actionName="Edit"
              handleAction={handleAction}
              // onSortToggle={onSortToggle}
              sortBy={sortBy}
              selectionAllowed={false}
            />
          </PageWrapper.Body>
        )}
      </PageWrapper>
    </div>
  );
}

export default OperatorConfig;
